import {
    IMAGE_UPLOAD_MAX_BYTES,
    FILE_UPLOAD_MAX_BYTES,
    COURSE_UPLOAD_ACCEPT,
    COURSE_UPLOAD_HINT,
    validateCourseFile,
} from './courseFiles';

export {
    formatFileSize,
    getAttachmentKind,
    isImageAttachment,
    ATTACHMENT_KIND_LABELS,
    asAttachmentList,
    canPreviewInBrowser,
} from './courseFiles';

export const COURSE_RESOURCE_LIMIT = 50;
export const RESOURCE_UPLOAD_ACCEPT = COURSE_UPLOAD_ACCEPT;
export const RESOURCE_UPLOAD_HINT = COURSE_UPLOAD_HINT;
export const RESOURCE_IMAGE_MAX_BYTES = IMAGE_UPLOAD_MAX_BYTES;
export const RESOURCE_FILE_MAX_BYTES = FILE_UPLOAD_MAX_BYTES;

export const validateResourceFile = (file) => validateCourseFile(file);
